import "./TourBadge.scss";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import IconCircuit from "app/pages/.shared/static/icons/WebsiteTunnelTypes/IconCircuit";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import PropTypes from "prop-types";

export const TourBadge = ({ className, hasBorder = false, ...props }) => {
	const tourBadgeClassName = classNames("tour-badge", {
		"tour-badge--border": hasBorder,
		[className]: className?.length > 0,
	});

	return (
		<span className={tourBadgeClassName} {...props}>
			<IconCircuit />

			<Typography
				variant={TYPOGRAPHY_VARIANTS.SMALL}
				component="span"
				isBold
				className="tour-badge__label"
			>
				<FormattedMessage id="product.tour" />
			</Typography>
		</span>
	);
};

TourBadge.propTypes = {
	hasBorder: PropTypes.bool,
};
